import React, { JSX } from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    TextField,
    SelectInput,
    required,
    ReferenceManyField,
    Datagrid,
    EditButton,
    Pagination,
} from 'react-admin';
import {
    Grid,
    Box,
} from '@mui/material';
import { miniGradeTypes, miniGradeMiniCodes } from "../../defaults/defaults";
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";

export const MiniGradeEdit: () => JSX.Element = (): JSX.Element => {

    return (
        <Edit redirect={ false }>
            <SimpleForm >
                <Grid container spacing={ 2 } sx={ { width: '100%' } }>
                    <Grid size={ 6 }>
                        <Box sx={ {
                            display: 'flex',
                            justifyContent: 'space-between'
                        } }>
                            <span>{ "ID" }</span>
                            <TextField source="id" />
                        </Box>
                        <TextInput name="name" source="name" validate={[required()]} />
                        <Box sx={ {
                            display: 'flex',
                            justifyContent: 'space-between'
                        } }>
                            <span>{ "System ID" }</span>
                            <TextField source="systemId" />
                        </Box>
                        <SelectInput source="type" choices={ miniGradeTypes } validate={[required()]} />
                        <SelectInput source="mini" choices={ miniGradeMiniCodes } validate={[required()]} />
                    </Grid>
                    <Grid size={ 6 }>
                        <Box sx={ {
                            display: 'flex',
                            flexDirection: 'column'
                        } } >
                            <h3>{ "Mini Results" }</h3>
                            <ReferenceManyField source="miniResults"
                                                pagination={ <Pagination /> }
                                                perPage={ 10 }
                                                reference="mini_results" target="id">
                                <Datagrid bulkActionButtons={ false } >
                                    <TextField source="id" />
                                    <TextField source="metricKey" />
                                    <TextField source="metricValue" />
                                    <TextField source="metricValueNumeric" />
                                    <EditButton label="View" />
                                </Datagrid>
                            </ReferenceManyField>
                        </Box>
                    </Grid>
                </Grid>
                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Edit>
    );
}
